import { isSectionShown, WEDDING } from "../data/content";

/**
 * Sage ornaments from the design, each on its own parallax speed so the
 * cluster drifts against the centred content block (which moves at -0.12).
 */
const ORNAMENTS = [
  { speed: "0.55", style: { right: -90, bottom: -60, width: 260, height: 260, opacity: 0.22 } },
  { speed: "0.45", style: { right: -80, top: 380, width: 320, height: 200, opacity: 0.12 } },
  { speed: "0.38", style: { right: 20, top: 80, width: 240, height: 240, opacity: 0.1 } },
  { speed: "0.70", style: { right: 240, top: 230, width: 18, height: 18, opacity: 0.9 } },
  { speed: "0.64", style: { right: 275, top: 262, width: 12, height: 12, opacity: 0.7 } },
  { speed: "0.76", style: { right: 215, top: 272, width: 9, height: 9, opacity: 0.5 } },
];

export function Hero() {
  return (
    <header id="home" className="hero">
      {/* Stands in for the watercolour sprig artwork; swap the gradient for
          the real asset when it exists. */}
      <div className="hero__sprig" data-par="0.30" aria-hidden="true" />

      {ORNAMENTS.map((o) => (
        <div
          key={o.speed}
          className="hero__ornament"
          data-par={o.speed}
          aria-hidden="true"
          style={o.style}
        />
      ))}

      <div className="hero__content" data-par="-0.12">
        <div className="monogram hero__monogram" role="img" aria-label="Aimee and Benjamin monogram" />
        <h1 className="hero__names">
          {WEDDING.brideFirst}
          <br />
          <span className="hero__amp">&amp;</span>
          <br />
          {WEDDING.groomFirst}
        </h1>
        <div className="hero__rule" aria-hidden="true" />
        <p className="hero__date">{WEDDING.dateLabel}</p>
        <p className="fine hero__venue">{WEDDING.venueLine}</p>
        <div className="hero__actions">
          {isSectionShown("rsvp") && (
            <a className="btn btn--primary" href="#rsvp">
              RSVP by May 1
            </a>
          )}
          {isSectionShown("schedule") && (
            <a className="btn btn--on-dark" href="#schedule">
              See the schedule
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
